 // Updated Navbar with IT Services Mega Mega Menu layout and Sidebar Mobile Menu
import React, { useEffect, useState } from "react";
import { HiChevronDown, HiMenu, HiX, HiChevronRight } from "react-icons/hi";
import { Link } from "react-router-dom";
import logoImg from "../assets/Best_IT_Tranning_Near_Me.png"; // Your main logo
import { FaPhone } from "react-icons/fa";

// IMPORTANT: Your custom logo image imports are correct!
import javaLogo from "../assets/CourseImg/Java.png";
import pythonLogo from "../assets/CourseImg/python.jpeg";
import cppLogo from "../assets/CourseImg/Best_CPP_Tranning_In_Noida.png";
import phpLogo from "../assets/CourseImg/php.png";
import reactLogo from "../assets/CourseImg/React.webp";
import angularLogo from "../assets/CourseImg/Best_Angular_Tranning_Near_By_Me.png";
import nodejsLogo from "../assets/CourseImg/node-js.png";
import webDesignLogo from "../assets/CourseImg/web-design.png";
import SEOLogo from "../assets/CourseImg/SEO.png";
import PPCLogo from "../assets/CourseImg/PPC.jpg";
import SMHLogo from "../assets/CourseImg/SMM.jpg";
import GoogleLogo from "../assets/CourseImg/Google.webp";
import EmailLogo from "../assets/CourseImg/Email.webp";
import VideoLogo from "../assets/CourseImg/Video.jpg";
import fullstack from "../assets/CourseImg/fullstacklogo.svg";
import machineLogo from "../assets/Internship/marketing_logo.png";
import frontlogo from "../assets/Internship/frontLogo.jpg";
import backlogo from "../assets/Internship/backlogo.png";
import uilogo from "../assets/Internship/uiLogo.jpg";
import datalogo from "../assets/Internship/Data_Science_logo.png";
import design  from "../assets/Internship/designLogo.jpg";


//Virtual Staffing Logo
import virtualLogo from "../assets/Virtual_Staffing/virtual_Assestant_logo.jpg";
import ITOutLogo from "../assets/Virtual_Staffing/IT_OutSourse.png";
import DigitalMLogo from "../assets/Virtual_Staffing/Digital_Logo.png";
import MedicalBLogo from "../assets/Virtual_Staffing/Billing_logo.avif";
import FinanceLogo from "../assets/Virtual_Staffing/Finance_logo.jpg";
import LegalLogo from "../assets/Virtual_Staffing/legal_logo.avif";

//It Services Logo
import webLogo from "../assets/IT-services/web_logo.png";
import WordLogo from "../assets/IT-services/word_logo.jpg";
import shopifyLogo from "../assets/IT-services/shopify_logo.webp";
import flutterLogo from "../assets/IT-services/flutter_logo.png";
import androidLogo from "../assets/IT-services/android_logo.jpg";
import iosLogo from "../assets/IT-services/IOS_logo.webp";

import seoLogo from "../assets/CourseImg/SEO.png";
import smmLogo from "../assets/CourseImg/SMM.jpg";
import ppcLogo from "../assets/CourseImg/PPC.jpg";

// Define TypeScript types for nav items
type SimpleNavItem = {
  title: string;
  dropdown: false;
  path: string;
};

type DropdownNavItem = {
  title: string;
  dropdown: true;
  mega?: false;
  subItems: { title: string; path: string; icon?: string }[]; // 'icon' can be emoji string or image path string
};

type MegaMenuCategory = {
  category: string;
  items: { title: string; path: string; icon: string }[]; // 'icon' MUST be an image path string for mega menu
};

type MegaMenuNavItem = {
  title: string;
  dropdown: true;
  mega: true;
  subItems: MegaMenuCategory[];
};

type NavItem = SimpleNavItem | DropdownNavItem | MegaMenuNavItem;

const navItems: NavItem[] = [
  { title: "Home", dropdown: false, path: "/" },
  { title: "About", dropdown: false, path: "/About_Us" },
  {
    title: "Virtual Staffing",
    dropdown: true,
    subItems:[
  { title: "Virtual-Assistant", path: "/Virtual_Assistant_In_Noida", icon: virtualLogo },
  { title: "IT OutSource", path: "/It_Outsourse_Tranning_In_Noida ", icon: ITOutLogo },
  { title: "Digital Marketing", path: "/Digital_Marketing_In_Noida", icon: DigitalMLogo },
  { title: "Medical Billing", path: "/Medical_Billing_In_Noida", icon: MedicalBLogo },
  { title: "Finance And Account", path: "/Finanace_Account_In_Noida", icon: FinanceLogo },
  { title: "Legal Proccess", path: "/Legal_Proccess_In_Noida", icon: LegalLogo }
]
  },
  {
    title: "IT Services",
    dropdown: true,
    mega: true,
    subItems: [
      {
        category: "Web Dev",
        items: [
          { title: "Custom Web Development", path: "/Custom_Web_Development_In_Noida", icon: webLogo },
          { title: "WordPress Web Dev.", path: "/Wordpress_Web_Development_In_Noida", icon: WordLogo },
          { title: "Shopify Web Development", path: "/Shopify_Web_Development_In_Noida", icon:shopifyLogo },
        ],
      },
      {
        category: "App Dev",
        items: [
          { title: "Flutter App Development", path: "/Flutter_App_Development_In_Noida", icon: flutterLogo },
          { title: "Android App Development", path: "/Android_App_Development_in_Noida", icon: androidLogo },
          { title: "IOS App Development", path: "/Ios-App-Development_In_Noida", icon: iosLogo },
        ],
      },
      {
        category: "Digital Marketing",
        items: [
          { title: "Search Engine Optimization", path: "/Search_Engine_Optimization_In_Noida", icon: seoLogo },
          { title: "Social Media Marketing", path: "/Social_Media_In_Noida", icon: smmLogo },
          { title: "Pay Per Click (PPC)", path: "/Pay_Per_Click_In_Noida", icon: ppcLogo },
        ],
      },
      
    ],
  },

    {
    title: "Course",
    dropdown: true,
    mega: true,
    subItems: [
      {
        category: "Programming Language",
        items: [
          { title: "JAVA Certification", path: "/JAVA_Certification_In_Noida", icon: javaLogo },
          { title: "Python Certification", path: "/Python_Certification_In_Noida", icon: pythonLogo },
          { title: "C/C++ Certification", path: "/C/C++_Certification_In_Noida", icon: cppLogo },
          { title: "Mern Certification", path: "/Mern_Certification_In_Noida", icon: reactLogo },
          { title: "PHP Certification", path: "/PHP_Certification_In_Noida", icon: phpLogo },
        ],
      },
      {
        category: "Full Stack",
        items: [
          { title: "PHP Full Stack Tranning ", path: "/PHP_FullStack_Tranning_In_Noida", icon: phpLogo },
          { title: "Python Full Stack Tranning", path: "/Python_Fullstack_In_Noida", icon: pythonLogo },
          { title: "Mern Full Stack Tranning ", path: "/Mern_FullStack__In_Noida", icon: reactLogo },
          { title: "JAVA Full Stack Tranning ", path: "/JAVA_FullStack_In_Noida", icon: javaLogo },
        ],
      },
      {
        category: "FrontEnd/BackEnd",
        items: [
          { title: "Web Designing Course", path: "/Web_Designing_Course_In_Noida", icon: webDesignLogo },
          { title: "Angular JS Course ", path: "/Anguler_Js_Course_In_Noida", icon: angularLogo },
          { title: "React JS Course", path: "/React_Js_Course_In_Noida", icon: reactLogo },
          { title: "JAVA Course ", path: "/JAVA_Course_In_Noida", icon: javaLogo },
          { title: "Node JS Course ", path: "/Node_Js_In_Noida", icon: nodejsLogo },
          { title: "Python Course ", path: "/Python_Course_In_Noida", icon: pythonLogo },
        ],
      },
      {
        category: "Digital Marketing",
        items: [
          { title: "SEO Expert", path: "/SEO_Expert_In_Noida", icon: SEOLogo },
          { title: "PPC Expert ", path: "/PPC_Expert_In_Noida", icon: PPCLogo },
          { title: "SMM/SMH Expert", path: "/SMM/SMH_Expert_In_Noida", icon: SMHLogo },
          { title: "Google Analytics", path: "/Google_Analytics_In_Noida", icon: GoogleLogo },
          { title: "E-mail Marketing ", path: "/Email_Marketing_In_Noida", icon: EmailLogo },
          { title: "Video Marketing ", path: "/Video_Marketing_In_Noida", icon: VideoLogo },
        ],
      },
    ],
  },

  {
    title: "Training Prog",
    dropdown: true,
    mega: true,
    subItems: [
      {
        category: "InternShip",
       items: [
  { title: "FrontEnd Certification", path: "/FrontEnd_Certification_In_Noida",  icon: frontlogo },
  { title: "BackEnd Certification", path: "/BackEnd_Certification_In_Noida",icon: backlogo },
  { title: "Full Stack Development", path: "/Full_Stack_Developer_In_Noida", icon: fullstack },
  { title: "UI/UX Designing Certification", path: "/UI/UX_Designing_Certification_In_Noida", icon: uilogo },
  { title: "Digital Marketing Certification", path: "/Digital_marketing_Developer_In_Noida", icon: machineLogo },
 
]
      },
      {
        category: "Industrial Training",
        items: [
          { title: "Web Development", path: "/Custom_Web_Development_In_Noida", icon: webLogo },
          { title: "Mobile Development", path: "/Android_App_Development_in_Noida", icon:androidLogo },
          { title: "Data Science", path: "/Data_Science_In_Noida", icon: datalogo },
          { title: "Graphic Designing", path: "/Graphic_Designing_In_Noida", icon: design },
          { title: "Digital Marketing", path: "/Digital_marketing_Developer_In_Noida", icon: machineLogo},
          { title: "UI/UX Designing", path: "/UI/UX_Designing_Certification_In_Noida", icon: "🧠" },
           { title: "Database Development", path: "/Database_Development_In_Noida", icon: backlogo }
        ],
      },
    ],
  },

  {
    title: "Career",
    dropdown: true,
    subItems: [
      { title: "Placement", path: "/Placement_In_Noida", icon: "💼" },
      { title: "Blog", path: "/blog", icon: "📝" },
      { title: "FAQ's", path: "/faq", icon: "❓" }
    ],
  },
];

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [openMobileDropdown, setOpenMobileDropdown] = useState<number | null>(null);
  const [openDesktopDropdown, setOpenDesktopDropdown] = useState<number | null>(null);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
    setOpenMobileDropdown(null);
  };

  const toggleMobileDropdown = (index: number) => {
    setOpenMobileDropdown(openMobileDropdown === index ? null : index);
  };

  const handleMouseEnter = (index: number) => {
    setOpenDesktopDropdown(index);
  };

  const handleMouseLeave = () => {
    setOpenDesktopDropdown(null);
  };

  const renderIcon = (iconValue: string | undefined, isMobile: boolean = false) => {
    if (!iconValue) return null;

    const isImagePath = typeof iconValue === 'string' && (
      iconValue.startsWith('/') || iconValue.startsWith('data:') || iconValue.includes('../assets/')
    );

    if (isImagePath) {
      return (
        <img
          src={iconValue}
          alt=""
          className={`${isMobile ? "h-4 w-4" : "h-5 w-5"} object-contain flex-shrink-0`}
        />
      );
    } else {
      return <span className={`${isMobile ? "text-base" : "text-lg"} flex-shrink-0`}>{iconValue}</span>;
    }
  };

  return (
    <>
      {/* Top Contact Bar */}
      {/* Ensure this bar doesn't overflow horizontally on small screens */}
      <div className="w-full bg-blue-900 text-white flex flex-col md:flex-row md:items-center md:justify-end overflow-x-hidden">
        <div className="flex items-center px-4 py-2 md:py-1 gap-2 text-sm md:justify-end w-full md:w-auto">
          <a href="tel:+919412220200" className="flex items-center gap-1 text-white hover:text-orange-600 flex-shrink-0">
            <FaPhone /> <span>+91 9412220200</span>
          </a>
        </div>
        <Link to="/contact" onClick={closeMobileMenu} className="w-full md:w-auto flex-shrink-0">
          <div className="bg-orange-500 text-white px-6 py-3 font-semibold md:min-w-[140px] hover:bg-orange-400 text-center w-full">
            Contact Us
          </div>
        </Link>
      </div>

      {/* Main Nav */}
      <div className={`w-full h-[74px] z-50 sticky top-0 transition-all duration-300 ${scrolled ? "bg-white shadow-md" : "bg-white"}`}>
        <div className="flex items-center px-4 md:px-10 py-3 md:py-4">
            {/* Logo and Mobile Menu Toggle Container */}
            <div className="flex items-center justify-between w-full md:w-auto"> {/* Adjusted for mobile */}
                 <Link to="/" className="flex items-center">
    <img
      src={logoImg}
      alt="Logo"
      className="h-9 md:h-10 w-auto flex-shrink-0"
      loading="eager"
    />
  </Link>
                {/* Mobile menu toggle button (moved inside the above div) */}
                <div className="md:hidden flex items-center">
                    <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="text-gray-800 focus:outline-none">
                        {mobileMenuOpen ? <HiX size={28} /> : <HiMenu size={28} />}
                    </button>
                </div>
            </div>

            {/* Desktop Navigation */}
            <ul className="hidden md:flex space-x-6 font-medium justify-center w-full ">
            {navItems.map((item, idx) => (
              <li
                key={idx}
                className="relative"
                onMouseEnter={() => handleMouseEnter(idx)}
                onMouseLeave={handleMouseLeave}
              >
                {item.dropdown ? (
                  <div className="relative">
                    <button className="flex items-center gap-1 hover:text-orange-500 py-4">
                      {item.title} <HiChevronDown size={16} />
                    </button>
                    {(openDesktopDropdown === idx) && (
                      item.mega ? (
                        <div className="absolute left-1/2 transform -translate-x-1/2 top-full mt-0 bg-white text-black shadow-xl rounded-b-md flex p-6 gap-10 z-50 min-w-[480px] border-t-2 border-orange-500">
                          {item.subItems.map((col, cIdx) => (
                            <div key={cIdx} className="flex-1 min-w-[150px]"> {/* Adjusted min-w for desktop columns, added flex-1 */}
                              <h4 className="font-bold text-lg border-b-2 border-gray-200 mb-3 pb-1">{col.category}</h4>
                              <ul className="space-y-2">
                                {col.items.map((service, sIdx) => (
                                  <li key={sIdx}>
                                    <Link to={service.path} className="flex items-center gap-2 px-2 py-1 rounded hover:bg-orange-100 hover:text-orange-700 transition-colors duration-200">
                                      {renderIcon(service.icon)}
                                      <span>{service.title}</span>
                                    </Link>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <ul className="absolute left-1/2 transform -translate-x-1/2 top-full mt-0 w-60 bg-white text-black shadow-lg rounded-b-md py-2 z-30 border-t-2 border-orange-500">
                          {item.subItems.map((subItem, subIdx) => (
                            <li key={subIdx}>
                              <Link to={subItem.path} className="flex items-center gap-2 px-4 py-2 hover:bg-orange-100 hover:text-orange-700 transition-colors duration-200">
                                {renderIcon(subItem.icon)}
                                <span>{subItem.title}</span>
                              </Link>
                            </li>
                          ))}
                        </ul>
                      )
                    )}
                  </div>
                ) : (
                  item.path ? (
                    <Link to={item.path} className="hover:text-orange-500 py-4 block">
                      {item.title}
                    </Link>
                  ) : (
                    <span className="hover:text-orange-500 cursor-default py-4 block">{item.title}</span>
                  )
                )}
              </li>
            ))}
          </ul>
        </div>

        {/* Mobile Menu Sidebar */}
        <div
          className={`fixed inset-0 bg-black bg-opacity-50 z-[999] transform transition-transform duration-300 md:hidden ${
            mobileMenuOpen ? "translate-x-0" : "-translate-x-full"
          }`}
          onClick={closeMobileMenu} /* Close sidebar when clicking overlay */
        >
          {/* Sidebar content - stop propagation to prevent closing when clicking inside */}
          <div
            className="bg-white w-4/5 max-w-xs min-w-[280px] h-full p-4 overflow-y-auto shadow-lg relative"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close button inside sidebar */}
            <button onClick={closeMobileMenu} className="absolute top-4 right-4 text-gray-800">
              <HiX size={28} />
            </button>
            {/* Logo in sidebar */}
            <img
              src={logoImg}
              alt="Logo"
              className="h-10 mb-8 w-auto"
              loading="eager"
            />

            <ul className="space-y-2 font-medium w-full">
              {navItems.map((item, idx) => (
                <li key={idx}>
                  {item.dropdown ? (
                    <>
                      <button
                        className="flex items-center justify-between w-full text-left py-2 hover:text-orange-500"
                        onClick={() => toggleMobileDropdown(idx)}
                      >
                        <span className="font-semibold">{item.title}</span>
                        {openMobileDropdown === idx ? <HiChevronDown size={20} /> : <HiChevronRight size={20} />}
                      </button>
                      {/* Collapsible Sub-menu */}
                      <div
                        className={`overflow-hidden transition-all duration-300 w-full ${
                          openMobileDropdown === idx ? "max-h-[1000px] opacity-100" : "max-h-0 opacity-0"
                        }`}
                      >
                        {item.mega ? (
                          item.subItems.map((col, cIdx) => (
                            <li key={cIdx} className="mt-2">
                              <h5 className="font-bold text-md mb-1 text-gray-700">{col.category}</h5>
                              <ul className="ml-2 space-y-1">
                                {col.items.map((service, sIdx) => (
                                  <li key={sIdx}>
                                    <Link
                                      to={service.path}
                                      className="flex items-center gap-2 text-sm py-1 hover:text-orange-500 max-w-full overflow-hidden text-ellipsis whitespace-normal" /* Added max-w-full, overflow classes */
                                      onClick={closeMobileMenu}
                                    >
                                      {renderIcon(service.icon, true)}
                                      <span className="flex-1 min-w-0">{service.title}</span> {/* Added flex-1 and min-w-0 to ensure text wraps */}
                                    </Link>
                                  </li>
                                ))}
                              </ul>
                            </li>
                          ))
                        ) : (
                          item.subItems.map((subItem, subIdx) => (
                            <li key={subIdx}>
                              <Link
                                to={subItem.path}
                                className="flex items-center gap-2 text-sm py-1 hover:text-orange-500 max-w-full overflow-hidden text-ellipsis whitespace-normal" /* Added max-w-full, overflow classes */
                                onClick={closeMobileMenu}
                              >
                                {renderIcon(subItem.icon, true)}
                                <span className="flex-1 min-w-0">{subItem.title}</span> {/* Added flex-1 and min-w-0 to ensure text wraps */}
                              </Link>
                            </li>
                          ))
                        )}
                      </div>
                    </>
                  ) : (
                    <Link
                      to={item.path}
                      className="block py-2 hover:text-orange-500"
                      onClick={closeMobileMenu}
                    >
                      {item.title}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;